import type { SashLayout } from '../../../common/types/nav';

// Nav bar spacing from Figma (GOE DA - Banorte), in theme.spacing units.

/** Header left padding: the corner ribbon overlays it, while the legacy sash chip sits after the logo. */
export const NAV_PADDING_LEFT: Readonly<Record<SashLayout, number>> = { ribbon: 5, legacy: 1.25, none: 2 };

export const NAV_PADDING_RIGHT = 4;

/** Between the header actions: notifications, language, tenant, user and contact. */
export const NAV_ACTIONS_GAP = 5.5;

/**
 * Moves the whole sash, ribbon and label together, down from the header's top edge. The ribbon artwork
 * (demo.svg / trial.svg) extends the same 2px above its box, so its top end still meets the header's top edge.
 */
export const NAV_SASH_TOP = 0.25;

// Demo/Trial label from Figma: a 41px-wide text box rotated -46°, whose bounding box starts 3px left of and 2px above
// the ribbon's top-left corner.
const SASH_LABEL_FIGMA = { boundsLeft: -0.375, boundsTop: -0.25, width: 5.125, rotation: -46 } as const;

/** CSS position of the label, which rotates about its start corner (the bounds' top edge comes from its far end). */
export const NAV_SASH_LABEL = {
    left: SASH_LABEL_FIGMA.boundsLeft,
    top: SASH_LABEL_FIGMA.boundsTop - SASH_LABEL_FIGMA.width * Math.sin((SASH_LABEL_FIGMA.rotation * Math.PI) / 180),
    rotation: SASH_LABEL_FIGMA.rotation,
    // Optical tweaks on top of Figma's box: room before the text along the ribbon (1px), and a nudge towards the
    // ribbon's longer outer edge to centre it visually (0.7px, i.e. about 0.5px right and 0.5px down).
    paddingLeft: 0.125,
    paddingTop: 0.0875
} as const;

/** Figma's Bold for the sash label: the shared 'TT Commons Pro' bold resolves to ExtraBold (see fonts.css). */
export const NAV_SASH_LABEL_FONT_FAMILY = '"TT Commons Pro Bold", "TT Commons Pro", sans-serif';

/** Between a header dropdown's label and its chevron. */
export const NAV_LABEL_CHEVRON_GAP = 1;
